/**
 * Compares two string version values.
 *
 * Example:
 * compareVersion('1.1', '1.2') => -1
 * compareVersion('1.1', '1.1') =>  0
 * compareVersion('1.2', '1.1') =>  1
 * compareVersion('2.23.3', '2.22.3') => 1
 *
 * Returns:
 * -1 = left is LOWER than right
 *  0 = they are equal
 *  1 = left is GREATER = right is LOWER
 *  And FALSE if one of input versions are not valid
 *
 * @function
 * @param {String} channelVersion  Version #1
 * @param {String} versionCompare Version #2
 * @return {Integer|Boolean}
 */
// eslint-disable-next-line complexity
export const compareVersion = (channelVersion, versionCompare) => {
  const a = channelVersion.split('.'),
    b = versionCompare.split('.'),
    len = Math.max(a.length, b.length)
  let i = 0

  for (; i < len; i++) {
    if (
      (a[i] && !b[i] && parseInt(a[i]) > 0) ||
      parseInt(a[i]) > parseInt(b[i])
    ) {
      return 1
    } else if (
      (b[i] && !a[i] && parseInt(b[i]) > 0) ||
      parseInt(a[i]) < parseInt(b[i])
    ) {
      return -1
    }
  }

  return 0
}
